/* global $, sgData, SGAction, shopSettings */
import WebLogger from './web-logger';

/**
 * CSS bug logger with some additional helpers
 */
class CSSBugLogger extends WebLogger {
  static checkIfCssLoaded(el) {
    // http://stackoverflow.com/a/2874506/1175227
    let cssLoaded = false;

    if (el.sheet && el.sheet.cssRules && el.sheet.cssRules.length > 0) {
      cssLoaded = true;
    } else if (el.styleSheet && el.styleSheet.cssText && el.styleSheet.cssText.length > 0) {
      cssLoaded = true;
    } else if (el.innerHTML && el.innerHTML.length > 0) {
      cssLoaded = true;
    }

    return cssLoaded;
  }

  static checkCSS(onSuccess, onError) {
    const stylesForPlatform = {
      iOSTablet: {
        fontFamily: 'Arial,Helvetica,sans-serif',
      },
      AndroidTablet: {
        fontFamily: 'Arial,Helvetica,sans-serif',
      },
      iOSPhone: {
        fontFamily: "system,-apple-system,'.SFNSDisplay-Regular','HelveticaNeue',HelveticaNeue,'LucidaGrande'",
      },
      AndroidPhone: {
        fontFamily: 'Roboto,sans-serif',
      },
      Web: {
        fontFamily: 'Arial,Helvetica,sans-serif',
      },
    };
    const body = document.body;
    const styles = getComputedStyle(body);
    let platformKey = 'Web';
    if (sgData.device.access === 'App') {
      platformKey = `${sgData.device.os}${sgData.device.type}`;
    }
    const desiredStyle = stylesForPlatform[platformKey].fontFamily;
    const styleEl = document.getElementById('global_css');
    const styleElExists = !!styleEl;
    const href = styleElExists ? styleEl.href : null;
    const fontFamilyGiven = styles.fontFamily ?
      styles.fontFamily.replace(/ /g, '').replace(/"/g, '\'') : '';

    if (fontFamilyGiven !== desiredStyle) {
      onError({
        styleElExists,
        styleEl,
        href,
        styles,
        desiredStyle,
      });
    } else {
      onSuccess({
        styleElExists,
        styleEl,
        href,
        styles,
        desiredStyle,
      });
    }
  }
}

export default CSSBugLogger;



// WEBPACK FOOTER //
// ./Library/1.0/common/web-logging/css-bug-logger.js